import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { PrivateEvents } from './components/PrivateEvents';
import { Experience } from './components/Experience';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { Location } from './components/Location';
import { Footer } from './components/Footer';
import { BookingModal } from './components/BookingModal';
export function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);
  const closeBooking = () => setBookingOpen(false);
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      {/* Skip to content */}
      <a href="#about" className="skip-to-content" data-id="element-1">
        Skip to content
      </a>

      <Navbar onOpenBooking={openBooking} data-id="element-2" />

      <main data-id="element-3">
        <Hero onOpenBooking={openBooking} data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <PrivateEvents data-id="element-7" />
        <Experience data-id="element-8" />
        <Gallery data-id="element-9" />
        <Reviews data-id="element-10" />
        <Location onOpenBooking={openBooking} data-id="element-11" />
      </main>

      <Footer data-id="element-12" />

      <BookingModal isOpen={bookingOpen} onClose={closeBooking} data-id="element-13" />
    </div>;
}